<div class="Flexbox Flexbox--column Gap--smaller ListContainer">
  @let bookmarks = bookmarksToShow() | async;
  @if (didCompleteInitialLoad() && (!bookmarks || bookmarks.length === 0)) {
    <div class="EmptyPrompt Flexbox Flexbox--column Align--center Justify--center">
      <div class="Flexbox Align--center">
        <mat-icon class="ThemeColorPrimary">favorite_outline</mat-icon>
        <span>Favorite a ring to get started</span>
      </div>
    </div>
  } @else {
    <div class="Flexbox Align--center Justify--flex-end">
      <button mat-button class="ClearAllButton" (click)="clearAllClicked()">Remove All</button>
    </div>
  }
  @for (bookmark of bookmarksToShow() | async; track $index) {
    <mat-card #bookmark [attr.bookmark-key]="visibleBookmarks().has(bookmark.sku) ? bookmark.key : undefined">
      <mat-card-content>
        <div class="Flexbox Flexbox--column Gap--smaller">
          <div class="Content Flexbox Align--center">
            <div class="ImageContainer Flexbox Flexbox--column Align--center">
              <img [src]="bookmark.imageData" [alt]="bookmark.sku">
              @if(visibleBookmarks().has(bookmark.sku)) {
                <div class="VisibilityKey">{{ getVisibilityLabel(bookmark) }}</div>
              }
            </div>
            <ul>
              <li>{{ bookmark.attributes.design?.displayName }}</li>
              <li>{{ getMaterials(bookmark) }}</li>
              <li>{{ bookmark.attributes.form?.shortName }} {{ bookmark.attributes.width?.displayName }} Sz. {{ bookmark.attributes.size?.displayName }}</li>
              @if (bookmark.attributes.gemstoneArrangement) {
                <li>{{ stoneCounts()?.get(bookmark.key) }}ctw {{ bookmark.attributes.gemstoneType?.displayName }}</li>
              }
              <li>
                <div class="PriceContainer Flexbox Flexbox--column Gap--tiny">
                  @if (isRetailerMode()) {
                    <app-price [price]="bookmark.retailPrice" [type]="'retailer'" [nowrap]="true"></app-price>
                  } @else {
                    <app-price [price]="bookmark.retailPrice" [type]="'retail'" [nowrap]="true"></app-price>
                  }
                </div>
              </li>
            </ul>
          </div>

          <div class="ButtonContainer Flexbox Align--center Justify--center">
            <button mat-icon-button (click)="removeClick(bookmark)"><mat-icon color="critical">close</mat-icon></button>
            <button mat-icon-button (click)="toggleVisible(bookmark)"><mat-icon class="ThemeColorPrimary">@if(visibleBookmarks().has(bookmark.sku)){visibility}@else{visibility_off}</mat-icon></button>
            <button mat-icon-button (click)="editClick(bookmark)"><mat-icon class="ThemeColorPrimary">edit</mat-icon></button>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  }
</div>
